import { defineComponent, onMounted, onUnmounted, h } from '@vue/composition-api';
import { withInstall } from '../util';
import { ElementVisible } from './element-visible';
var Visible = defineComponent({
  name: 'm-visible',
  slots: ['default'],
  emits: ['visible', 'invisible'],
  setup: function setup(props, context) {
    var ev;
    onMounted(function () {
      var childEl = context.refs.child;
      ev = new ElementVisible({
        el: childEl,
        visible: function visible(count) {
          // 变可见
          context.emit('visible', count);
        },
        invisible: function invisible(count) {
          // 变不可见
          context.emit('invisible', count);
        }
      });
      ev.bind();
    });
    onUnmounted(function () {
      ev.unbind();
    });
    return function () {
      var _context$slots$defaul, _context$slots;

      return h("span", {
        "ref": "child"
      }, [(_context$slots$defaul = (_context$slots = context.slots)["default"]) === null || _context$slots$defaul === void 0 ? void 0 : _context$slots$defaul.call(_context$slots)]);
    };
  }
});
withInstall(Visible);
export default Visible;